import { CongSettings } from "../../../types/scheduling/settings";
import { OtherSchedule } from "../../../types/scheduling/other";
import { FSGroup } from "../../../types/fsgroup";
import User from "../../../types/user";
import { getGroupDisplayName } from "../../../helpers/fsgroup";

export function cleaningAssigneeName(
  schedule: OtherSchedule,
  userMap: Map<number, User>,
  fsGroups: FSGroup[],
  settings: CongSettings,
): string {
  const userId = schedule.assigneeUserId ?? 0;
  if (schedule.individual) {
    return userMap.get(userId)?.displayName ?? "";
  }
  // Check if it's a group overseer
  const fsGroup = fsGroups.find((g) => g.overseer_id === userId);
  if (fsGroup) {
    return getGroupDisplayName(fsGroup, userMap, settings.congregation_groups_use_label);
  }
  // Fall back to user name
  return userMap.get(userId)?.displayName ?? "";
}

export function cleaningLabel(settings: CongSettings, slot: number): string {
  switch (slot) {
    case 0:
      return settings.cleaning_label_1;
    case 1:
      return settings.cleaning_label_2;
    case 2:
      return settings.cleaning_label_3;
    case 3:
      return settings.cleaning_label_4;
    case 4:
      return settings.cleaning_label_5;
    case 5:
      return settings.cleaning_label_6;
    case 6:
      return settings.cleaning_label_7;
    case 7:
      return settings.cleaning_label_8;
  }

  return "";
}
